export default "/images/3c77a0e4f57ddb6aa7e7aedb3119206a.avif";